import type {
  StepBlockFragment,
  StepBlockGroupFragment,
} from '@seek/cmsu-cms-connect';
import { Box, Stack } from 'braid-design-system';
import React from 'react';
import { Heading, Paragraph } from '..';
import { useCMSUContext } from '../../hooks/useCMSUContext';
import {
  ConditionalWrapper,
  useBackgroundProps,
  useStepIndicatorBackgroundProps,
} from './helper';

type StepBlockGroupGeneratedProps = {
  index: number;
};
type StepBlockProps = Pick<StepBlockFragment, 'heading' | 'paragraph'> &
  Pick<StepBlockGroupFragment, 'inlineBlockItem' | 'tile'> &
  StepBlockGroupGeneratedProps;

export const StepBlock = ({
  index,
  heading,
  paragraph,
  inlineBlockItem,
}: StepBlockProps) => {
  const { country } = useCMSUContext();
  const isAnz = country === 'au' || country === 'nz';

  return (
    <Box
      {...useBackgroundProps(isAnz)}
      height="full"
      padding="large"
      textAlign="center"
      borderRadius="xlarge"
      data-testid="StepBlockTestId"
    >
      <Stack space="medium">
        <ConditionalWrapper
          condition={Boolean(inlineBlockItem)}
          wrapper={(children) => <Box display="flex">{children}</Box>}
        >
          <>
            <Box
              {...useStepIndicatorBackgroundProps(isAnz)}
              display="inlineBlock"
              borderRadius="full"
              padding="medium"
              {...(!inlineBlockItem && { marginBottom: 'medium' })}
            >
              <Heading level={3} text={`${index + 1}`} />
            </Box>
            <ConditionalWrapper
              condition={Boolean(inlineBlockItem)}
              wrapper={(children) => (
                <Box marginLeft={'medium'} textAlign="left">
                  {children}
                </Box>
              )}
            >
              <Stack space="medium">
                {Boolean(heading) && (
                  <Heading {...heading} text={heading?.text || ''} />
                )}
                {paragraph?.Paragraph_text && (
                  <Paragraph
                    content={paragraph.Paragraph_text.raw}
                    align={paragraph.align}
                    tone={paragraph.tone}
                    size={paragraph.size}
                  />
                )}
              </Stack>
            </ConditionalWrapper>
          </>
        </ConditionalWrapper>
      </Stack>
    </Box>
  );
};
